class mAccountProfile extends HTMLDivElement {
    constructor() {
        super();
        this.menu = this.querySelector('[is="m-account-menu-mobile"]');
        this.form = this.querySelector('form');
        this.toggleButton = this.querySelectorAll('.profile-toggle');
        this.cancel = this.querySelector('.profile-cancel');
        this.titleHello = this.querySelector('.title-hello');
        this.titleMenu = this.querySelector('.title-menu');

        this.contentPhone = this.querySelector('[data-field-type="phone"]');
    }

    connectedCallback() {
        this.toggleButton.forEach((el) => {
            el.addEventListener('click', () => {
                this.toggleDashboard(el);
            });
        });
    }

    toggleDashboard() {
        this.form.classList.toggle('d-none');
        this.menu.classList.toggle('d-none');
        this.cancel.classList.toggle('d-none');
        this.titleMenu.classList.toggle('d-none');
        this.titleHello.classList.toggle('d-none');
    }
}

customElements.define('m-account-profile', mAccountProfile, {
    extends: 'div'
});
